import { getApiToken } from "./side_effects";
import { AuthState } from "./types";

export const authPersistedState = (): AuthState => ({ hasToken: !!getApiToken(), isLoading: false });
